module.exports = __webpack_public_path__ + "media/images/ninestars/team/team-3-ca581ae1628e295ec2a0fd2b35a0e67e.jpg";